<!-- 会员管理-积分规则 -->

<template>
  <div class="rule-container main-cnt">
    <div class="title">积分规则</div>
    <div class="content">
      <common-table ref="tableRef" tableHeight="calc(100vh - 320px)" :apiName="VipApi.getIntegration"
        :columns="tableColumns" @onUsageDetails="onUsageDetails">
        <template #operate>
          <el-button type="primary" round @click="openDialog"
            v-if="authData.indexOf('m_227d3327e218d53dbe5d9fghgf') != -1">
            <el-icon><i class="iconfont icon-a-lianhe4"></i></el-icon>
            新增规则
          </el-button>
        </template>

        <!-- 细则 -->
        <template #ir_way_label="{ row }">
          <div class="text-black flex">
            <div class="dots" :class="row.ir_way == 1 ? 'bg-blue' : 'bg-orange'"></div>
            <div>{{ row.ir_way_label }}</div>
          </div>
        </template>

        <!-- 生效时间 -->
        <template #effectiveDate="{ row }">
          <div class="text-black flex">
            <div>{{ row.ir_stime }}</div>
            <div v-if="row.ir_etime">至{{ row.ir_etime }}</div>
            <div class="permanent" v-if="!row.ir_etime">永久</div>
          </div>
        </template>

        <!-- 状态 -->
        <template #ir_valid_label="{ row }">
          <div class="valid-label"
            :class="row.ir_status == 1 ? 'btn-green' :row.ir_status == 2 ? 'btn-black' : 'btn-red'">
            {{ row.ir_valid_label }}</div>
        </template>

        <!-- 强制下架 -->
        <template #forced_delist="{ row }">
          <template v-if="(row.ir_status == 1 || row.ir_status == 0) && authData.indexOf('m_785d6e86510d4d9720f7d4a105c') != -1">
            <el-button class="theme-font-btn" @click="onForcedDelist(row)">强制下架</el-button>
          </template>
        </template>
      </common-table>
    </div>

    <!-- 新增规则 -->
    <w-dialog ref="dialogRef" class="rule-dialog" title="新增规则" width="40%" btnWidth="140px" top="20vh"
      confirmText="确认保存" @wConfirm="handleSure">
      <el-form class="add-form" ref="formRef" :model="ruleForm" :rules="rules" labelPosition="top">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="规则名称" prop="ir_title">
              <el-input v-model="ruleForm.ir_title" clearable placeholder="请输入规则名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="规则类型" prop="ir_type">
              <el-select v-model="ruleForm.ir_type" placeholder="请选择规则类型" clearable @change="typeChange">
                <el-option :label="item.name" :value="item.id" v-for="(item, index) in ruleTypeOption" :key="index">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="ruleForm.ir_type == '1'">
            <el-form-item label="积分方式" prop="ir_way">
              <el-select v-model="ruleForm.ir_way" placeholder="请选择积分方式" clearable @change="wayChange">
                <el-option :label="item.name" :value="item.id" v-for="(item, index) in modeOption" :key="index">
                </el-option>
              </el-select>
            </el-form-item>
            <div class="text-remarks" v-if="ruleForm.ir_way == '1'">实付积分按照消费的实际金额积分，小数部分不积分</div>
          </el-col>
          <el-col :span="12" v-if="ruleForm.ir_way == '2'">
            <el-form-item label="消费金额" prop="ir_consumption_money">
              <el-input v-model="ruleForm.ir_consumption_money" clearable placeholder="请输入消费金额" type="number"
                oninput="if(value<0)value=0">
                <template #append>元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="ruleForm.ir_way == '2' || ruleForm.ir_type == '4'">
            <el-form-item label="积分数量" prop="ir_integration_num">
              <el-input v-model="ruleForm.ir_integration_num" clearable placeholder="请输入积分数量" type="number"
                oninput="if(value<0)value=0">
                <template #append>分</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生效时间" prop="ir_stime">
              <el-date-picker v-model="ruleForm.ir_stime" type="date" clearable value-format="YYYY-MM-DD"
                placeholder="请选择生效时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="失效时间" prop="ir_etime">
              <el-date-picker v-model="ruleForm.ir_etime" type="date" clearable value-format="YYYY-MM-DD"
                placeholder="请选择失效时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </w-dialog>

    <!-- 使用详情 -->
    <UsageDetails ref="refUsageDetails" @submit="submit"></UsageDetails>
  </div>
</template>

<script setup>
  import { ref, reactive, onMounted, watch, computed, } from "vue";
  import { VipApi, BasicApi } from "@/plugins/api.js";
  import { ElMessage, ElMessageBox, } from "element-plus";
  import UsageDetails from "../components/UsageDetails.vue";
  import { useStore } from "vuex";

  // 权限
  const store = useStore();
  const menuTokens = computed(() => store.state.menuToken.menuTokens);
  const authData = ref([]);
  watch(
    () => menuTokens.value,
    (data) => {
      if (data.length) {
        authData.value = data;
      }
    },
    {
      deep: true,
      immediate: true,
    }
  );

  onMounted(() => {
    tableRef.value.tableLoad();
  });
  const tableRef = ref(null);  // 表格对象
  /** 表格配置数据 */
  const tableColumns = ref([
    {
      prop: "ir_title",
      label: "规则名称",
    },
    {
      prop: "ir_type_label",
      label: "规则类型",
    },
    {
      prop: "ir_way_label",
      label: "细则",
      type: "customRender",
    },
    {
      type: "block",
      prop: "used_num",
      label: "使用详情",
      active: "onUsageDetails",
      minWidth: 80,
      token: "m_df1c53f45f648f53eb95531ghg",
    },
    {
      prop: "effectiveDate",
      label: "生效时间",
      type: "customRender",
    },
    {
      prop: "ir_valid_label",
      label: "状态",
      type: "customRender",
    },
    {
      type: "operation",
      prop: "",
      label: "操作",
      minWidth: 100,
      bottons: [
        {
          name: "强制下架",
          action: "forced_delist",
          type: "customRender",
        },
      ],
    },
  ]);

  const dialogRef = ref(null);  // 新增规则弹框对象
  const formRef = ref(null);  // 表单对象
  const ruleTypeOption = ref([
    { id: 1, name: '消费积分' },
    // { id: 2, name: '行为积分' },
    // { id: 3, name: '等级积分' },
    { id: 4, name: '认证房产积分' },]);  // 规则类型选项
  const modeOption = ref([{ id: 1, name: '实付积分' }, { id: 2, name: '满额积分' },]);  // 积分方式选项
  // 填写表单内容
  const ruleForm = ref({
    ir_title: '',  // 积分规则名称
    ir_type: '',  // 规则类型  1: 消费积分；2：行为积分；3：等级积分；4：认证房产积分
    ir_way: '',  // 积分方式  1: 实付积分；2：满额积分
    ir_consumption_money: 0,  // 消费金额
    ir_integration_num: 0,  // 积分数量
    ir_stime: '',  // 生效时间
    ir_etime: '',  // 失效时间
  });
  // 验证必填项
  const rules = reactive({
    ir_title: [
      { required: true, message: "请输入规则名称", trigger: "blur", },
    ],
    ir_type: [
      { required: true, message: "请选择规则类型", trigger: "change", },
    ],
    ir_way: [
      { required: true, message: "请选择积分方式", trigger: "change", },
    ],
    ir_consumption_money: [
      { required: true, message: "请输入消费金额", trigger: "blur", },
    ],
    ir_integration_num: [
      { required: true, message: "请输入积分数量", trigger: "blur", },
    ],
    ir_stime: [
      { required: true, message: "请选择生效时间", trigger: "change", },
    ],
  });
  const refUsageDetails = ref(null);  // 使用详情对象
  /**
   * 
   * 打开新增规则弹框
   * 
   * **/
  const openDialog = () => {
    ruleForm.value = {
      ir_title: '',
      ir_type: '',
      ir_way: '',
      ir_stime: '',
      ir_etime: '',
      ir_consumption_money: 0,
      ir_integration_num: 0,
    };
    dialogRef.value.show();
  };
  /**
   * 
   * 选择规则类型
   * 
   * **/
  const typeChange = () => {
    ruleForm.value.ir_way = '';
    ruleForm.value.ir_consumption_money = 0;
    ruleForm.value.ir_integration_num = 0;
  }
  /**
   * 
   * 选择积分方式
   * 
   * **/
  const wayChange = () => {
    ruleForm.value.ir_consumption_money = 0;
    ruleForm.value.ir_integration_num = 0;
  }
  /**
   * 
   * 新增规则确认提交
   * 
   * **/
  const handleSure = () => {
    formRef.value.validate((valid) => {
      if (valid) {
        if (ruleForm.value.ir_etime) {
          if (ruleForm.value.ir_stime > ruleForm.value.ir_etime) {
            ElMessage.error('生效时间不能大于失效时间！');
            return false;
          }
        }
        dialogRef.value.isLoading = true;
        const parmas = JSON.parse(JSON.stringify(ruleForm.value));
        VipApi.addIntegration(parmas).then((res) => {
          dialogRef.value.isLoading = false;
          if (res.Code === 200) {
            // console.log("parmas", parmas, res);
            ElMessage.success('新增成功！');
            dialogRef.value.close();
            tableRef.value.tableLoad();
          } else {
            ElMessage.error(res.Message);
          }
        });
      }
    });
  };
  /**
   * 
   * 点击使用详情数量
   * 
   * **/
  const onUsageDetails = (row) => {
    refUsageDetails.value.openDialog(row);
  }
  /**
   * 
   * 使用详情提交
   * 
   * **/
  const submit = () => {
    tableRef.value.tableLoad();
  }
  /**
   * 
   * 强制下架按钮
   * 
   * **/
  const onForcedDelist = (row) => {
    ElMessageBox.confirm("是否确认强制下架改积分规则，下架后不可再继续使用?", "强制下架提示", {
      confirmButtonText: "确认",
      cancelButtonText: "取消",
    })
      .then(() => {
        VipApi.getIntegrationUnused({ ir_id: row.ir_id }).then((res) => {
          if (res.Code === 200) {
            ElMessage.success('强制下架成功！');
            tableRef.value.tableLoad();
          } else {
            ElMessage.error(res.Message);
          }
        });
      })
      .catch(() => { });
  }
</script>
<style lang="scss">
  .rule-container {
    font-family: "Source Han Sans CN";

    .content {
      padding: 15px 20px 20px;
    }

    .text-black {
      color: var(--text-color);
    }

    .dots {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      margin: 8px 5px 0 0;
    }

    .permanent {
      width: 40px;
      height: 24px;
      border-radius: 4px;
      background-color: var(--search-bg-color);
      color: var(--theme-color);
      text-align: center;
      margin-left: 5px;
    }

    .valid-label {
      width: 54px;
      height: 24px;
      border-radius: 4px;
      text-align: center;
    }

    .rule-dialog {
      .el-dialog {
        min-width: 600px;

        .el-dialog__body {
          padding: 30px;

          .el-divider--horizontal {
            margin: 10px 0;
          }
        }
      }
    }

    .el-input-group__append {
      background-color: var(--search-uncheck-bg-color);
      border: none;
    }

    .text-remarks {
      color: #FA7D00;
      font-size: 12px;
    }
  }
</style>